import React, { useEffect, useState } from "react";
import HeaderText from "../components/headerText/HeaderText";
import Customers from "../components/customers/Customers";
import AddCustomers from "../components/customers/addCustomers/AddCustomers";
import accessURL from "../../components/utils/access";

const Customer = () => {
  const [targets, setTargets] = useState<{
    A: number;
    B: number;
    C: number;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchTargets();
  }, []);

  const fetchTargets = async () => {
    try {
      const res = await accessURL(`targets/getTargets`);
      setTargets(res?.data?.data);
    } catch (error) {
      console.error("Error fetching targets:", error);
    } finally {
      setLoading(false);
    }
  };

  const hasValidTargets =
    targets && (targets.A > 0 || targets.B > 0 || targets.C > 0);

  if (loading) {
    return (
      <div className="p-4 md:p-6 lg:p-8 xl:p-14">
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="text-gray-500">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 lg:p-8 xl:p-14">
      <section className="flex flex-col lg:flex-row justify-between items-center py-3">
        <HeaderText text="customers" />
        {hasValidTargets && (
          <div className="flex flex-col-reverse space-y-10 space-x-0 md:flex-col lg:space-y-0 lg:space-x-10 lg:flex-row">
            <AddCustomers />
          </div>
        )}
      </section>

      {!hasValidTargets ? (
        <div className="mt-8 p-6 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-center text-gray-600 text-lg font-medium">
            Admin has not updated targets yet. You cannot add customers at this
            time.
          </p>
          <p className="text-center text-gray-500 mt-2">
            Please contact your administrator to set up customer targets.
          </p>
        </div>
      ) : (
        <section>
          <Customers />
        </section>
      )}
    </div>
  );
};

export default Customer;
